import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Modal from 'react-modal';
import pluralize from 'pluralize';

import Button from '../../../../components/global/Button';

const PlicBooksProgressBanner = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const { pendingPhotosCount, exportedPhotosCount, completed } = useSelector(
    ({ plicBooks }) => plicBooks,
  );

  useEffect(() => {
    // Opens automatically as soon exportedPhotosCount change.
    // This means a new upload happened pretty much.
    if (exportedPhotosCount > 0 && !isOpen) {
      setIsOpen(true);
    }
  }, [exportedPhotosCount, completed]);

  useEffect(() => {
    if (completed) {
      setSuccess(true);
    } else {
      setSuccess(false);
    }
  }, [completed]);

  return (
    <Modal
      ariaHideApp={false}
      isOpen={isOpen}
      bodyOpenClassName="plic-books-progress-banner-body-open"
      overlayClassName="plic-books-progress-banner-overlay"
      className="plic-books-progress-banner"
    >
      <div className="d-flex justify-space-between align-items-center">
        {success ? (
          <div>
            <p className="my-0">
              Success!{' '}
              <span className="text-primary">{exportedPhotosCount}</span>{' '}
              {pluralize('photo', exportedPhotosCount)} have been exported to
              PLIC Books
            </p>
          </div>
        ) : (
          <div>
            Exporting{' '}
            <span className="text-primary">{exportedPhotosCount}</span>{' '}
            {pluralize('photo', exportedPhotosCount)} to PLIC Books
          </div>
        )}
        <Button
          btnStyle="link"
          className="text-gray-dark text-bold ml-auto"
          btnSize="sm"
          onClick={() => setIsOpen(false)}
        >
          Dismiss
        </Button>
      </div>

      {!success && (
        <div className="progress mt-2">
          <div
            className="progress-bar"
            style={{
              width: `${Math.min(
                pendingPhotosCount / exportedPhotosCount,
                1,
              )}%`,
            }}
          />
        </div>
      )}
    </Modal>
  );
};

export default PlicBooksProgressBanner;
